// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface ConsoleSession {
  token: string;
  mfa_code?: string | null;
}

export interface SessionClaims {
  id: string;
  usn: string;
  ema: string;
  rol: number;
  exp: number;
  cki: string;
}

export interface MFAClaims {
  user_id: string;
  user_email: string;
  exp: number;
  crt: number;
  secret: string;
  mfa_url: string;
  mfa_required: boolean;
}

export interface AuthenticateRequest {
  username: string;
  password: string;
  mfa?: string;
}

export interface AuthenticateMFASetupRequest {
  mfa: string;
  code: string;
}

export interface AuthenticateMFASetupResponse {
  success: boolean;
}

export enum UserRole {
  USER_ROLE_UNKNOWN = 0,
  USER_ROLE_ADMIN = 1,
  USER_ROLE_MODIFIER = 2,
}

export interface LoginFormData {
  username: string;
  password: string;
  code: string;
}
